import * as React from 'react';

function ArrowDown2Icon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="arrow-down-2-icon_svg__icon"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      aria-hidden="true"
      fill="currentColor"
      {...props}
    >
      <defs>
        <style />
      </defs>
      <path d="M472.064 751.552L72.832 352.32c-22.08-22.08-22.08-57.792 0-79.872 22.016-22.016 57.792-22.08 79.872 0L512 631.744l359.296-359.296c22.016-22.016 57.792-22.08 79.872 0s22.016 57.792 0 79.872L551.936 751.552c-22.08 22.016-57.792 22.016-79.872 0z" />
    </svg>
  );
}

export default ArrowDown2Icon;
